import { FC } from 'react';
import { Container, UserPicture, UserInfo, UserName } from './UserProfile.styles';
import { TUser } from '../../services/user/user.types';

interface UserProfileProps {
	user: TUser;
}

const UserProfile: FC<UserProfileProps> = ({ user }) => {
	return (
		<Container>
			<UserPicture src={`${process.env.PUBLIC_URL}/images/user.png`} />
			<UserName>{user.nome}</UserName>
			<UserInfo>{user.email}</UserInfo>
			<UserInfo>Perfil: {user.grupoAcesso.nome}</UserInfo>
			<UserInfo>Cadastrado em: {new Date(user.dataCadastro).toLocaleDateString('pt-BR')}</UserInfo>
		</Container>
	);
};

export default UserProfile;
